/** Shared footer. Content from shared/config.ts (mockup's CONFIG.SHELL). */
import styles from "./Footer.module.scss";
import { SHELL } from "@shared/config";

export const Footer: React.FC = () => (
  <footer className={styles.footer}>
    <span className={styles.copy}>
      <b>{SHELL.company}</b> © {SHELL.year} · {SHELL.product}
    </span>
    <span className={styles.version}>{SHELL.version}</span>
  </footer>
);
